import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/credits.jsx';
import {apiback} from '../../../config';
import CreditsModel from '../Models/credits.m.js';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            model: {},
            mode: 'account_credit_limit_ur',
            showFull: false,
            showModal: false,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };
        this.widgetsHelper = widgetsHelper;
        this.toggleMode = this.toggleMode.bind(this);
        this.toggleList = this.toggleList.bind(this);
        this.toggleModal = this.toggleModal.bind(this);

        return this;
    }

    toggleMode(event) {
        const {mode} = event.detail;

        this.setState({mode});
        this.state.model.changeField('mode', mode);
    }

    componentWillReady(resolve) {
        resolve();
        this.widgetsHelper.getWidgets.call(this);
        document.addEventListener('switchCalcMode', this.toggleMode);
        fetch(apiback('ACCOUNT_CREDIT_CALC'))
            .then(res => res.json())
            .then(json => {
                const model = new CreditsModel(json.data, this.state.mode);
                this.setState({model});
            })
            .then(this.scrollToCalc);
    }

    componentWillUnmount() {
        document.removeEventListener('switchCalcMode', this.toggleMode);
    }

    toggleList(e) {
        this.setState({showFull: !this.state.showFull});
        e.target.classList.toggle('active');
    }

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }

    scrollToCalc = () => {
        const currentURL = window.location.href;
        const targetElement = document.querySelector('.credit-calculator');
        if (currentURL.includes('rko/calc')) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    };

    static displayName = 'Business.Views.Credits';

    static contextTypes = {
        app: PropTypes.object
    };
}
